module.exports = __webpack_public_path__ + "static/media/user-redeem-points.21ba8865.svg";